import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=12bdf663&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=12bdf663&prod&lang=scss&scoped=true"
import style1 from "./RegisterForm.vue?vue&type=style&index=1&id=12bdf663&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bdf663",
  null
  
)

export default component.exports